import type { Part } from "./part";

export const EMPTY_PART_ID = "00000000-0000-4000-8000-empty000000part";

export const EMPTY_PART: Part = {
	id: EMPTY_PART_ID,
	partNumber: "",
	partName: "",
	siteId: null,
	imageBlobPath: null,
	active: true,
	createdAt: new Date(0),
	updatedAt: new Date(0),
};

export function isEmptyPart(idOrPart: string | Part | null | undefined): boolean {
	if (!idOrPart) return false;
	return typeof idOrPart === "string" ? idOrPart === EMPTY_PART_ID : idOrPart.id === EMPTY_PART_ID;
}
